import { select, takeEvery, put } from 'redux-saga/effects'
import { SET_IS_READY } from '@actions/types'

const getReadyData = state => state.initialize

/**
 * Sets appIsReady to true once all other ready flags in the initialize state are true.
 */
function * onSetIsReady() {
  const { appIsReady, ...readyData } = yield select(getReadyData)

  if (appIsReady) return

  const values = Object.values(readyData)

  if (values.some(item => item === false)) return

  yield put({
    type: SET_IS_READY,
    payload: {
      appIsReady: true
    }
  })
}

/**
 * Registers a watcher to check app readiness whenever a ready flag is set.
 */
function * watchInitialize() {
  yield takeEvery(SET_IS_READY, onSetIsReady)
}

export default watchInitialize
